import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Page from '../../../containers/Page';
import PageFooter from '../../../containers/PageFooter';
import AnalyticsTrackers from '../../../containers/AnalyticsTrackers';
import LandingPageContainer from '../containers/LandingPageContainer';
import { alternateLocaleUrlsSelector, hasQueryParamsSelector } from '../selectors';
import { getLandingPagePath } from '../utils';

function DynamicLandingPage({
  pageTitle,
  metaDescription,
  ogTitle,
  ogDescription,
  themeColor,
  image,
  metadata,
  landingPagePath,
  alternateLocales,
  robots,
}) {
  return (
    <Page
      pageName="landing-page"
      pageTitle={pageTitle}
      metaDescription={metaDescription}
      ogTitle={ogTitle}
      ogDescription={ogDescription}
      color={themeColor}
      image={image}
      metadata={metadata}
      pagePath={landingPagePath}
      alternateLocales={alternateLocales}
      robots={robots}
    >
      <LandingPageContainer />
      <PageFooter />
      <AnalyticsTrackers />
    </Page>
  );
}

DynamicLandingPage.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  metaDescription: PropTypes.string.isRequired,
  ogTitle: PropTypes.string,
  ogDescription: PropTypes.string,
  themeColor: PropTypes.string,
  image: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    src: PropTypes.string.isRequired,
  }),
  metadata: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      property: PropTypes.string,
      content: PropTypes.string.isRequired,
    }),
  ),
  landingPagePath: PropTypes.string.isRequired,
  alternateLocales: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      hrefLang: PropTypes.string.isRequired,
    }),
  ).isRequired,
  robots: PropTypes.string,
};

DynamicLandingPage.defaultProps = {
  robots: undefined,
  ogTitle: undefined,
  ogDescription: undefined,
  themeColor: undefined,
  image: undefined,
  metadata: [],
};

function mapStateToProps(state) {
  const {
    pageTitle,
    metaDescription,
    ogTitle,
    ogDescription,
    themeColor,
    image,
    metadata,
  } = state.landingPage;
  const alternateLocales = alternateLocaleUrlsSelector(state);
  const robots = hasQueryParamsSelector(state) ? 'noindex, nofollow' : undefined;

  return {
    pageTitle,
    metaDescription,
    ogTitle,
    ogDescription,
    themeColor,
    image: image
      ? {
          width: 1200,
          height: 630,
          src: image,
        }
      : undefined,
    metadata,
    landingPagePath: getLandingPagePath(state.request),
    alternateLocales,
    robots,
  };
}

export default connect(mapStateToProps)(DynamicLandingPage);
